import { WarningOutline18Icon } from "@vygruppen/spor-icon-react";
import { InvisibleButton } from "features/VehicleSidebar/VehicleList/TrainList/styles";
import { useTranslation } from "react-i18next";
import { Text, DropsTooltip } from "shared/components/Spor";
import { CountryCode } from "shared/types/countryCode";
import { useTheme } from "styled-components";

export const HasCancellationsIcon = ({
  countryCode,
  withTooltip,
}: {
  countryCode: CountryCode;
  withTooltip?: boolean;
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const text = t("Innstilt fra {{infrastructureProvider}}", {
    infrastructureProvider: countryCode === "SE" ? "TRV" : "BN",
  });

  return withTooltip ? (
    <DropsTooltip hasArrow label={text} placement="top">
      <InvisibleButton>
        <WarningOutline18Icon color={theme.colorWarning} />
      </InvisibleButton>
    </DropsTooltip>
  ) : (
    <>
      <WarningOutline18Icon color={theme.colorWarning} />
      <Text variant="sm">{text}</Text>
    </>
  );
};
